require('./hireCardPremiumPackError.scss');

// @ vendors
const PropTypes = require('prop-types');
const React = require('react');
const { withRouter } = require('react-router-dom');

// @ helpers
const { FormattedText, formatText } = require('core/i18n').i18n;

// @commons
const WizardError = require('components/commons/wizardError/wizardError');

// @constants
const {
    KNOWN_ERROR_CODE,
    REJECTED,
    LOW_CREDIT_SCORE
} = require('constants/hireCardSubmitScenarios');
const { catalogue, analyticsId } = require('../analytics/hireCardPremiumPackAnalytics');

class HireCardPremiumPackError extends React.Component {

    handleGoToDocumentation() {
        this.props.history.push('/myprofile/documentation');
    }

    buildTexts() {
        const { immHireCardPremiumPack, hasAvailableAccounts, maxAllowedNumberCards, hireRestrictionFlag } = this.props;
        let titleKey = 'hireCardPremiumPack-errorTitleGeneric';
        let textElement = (
            <div className="hire-card-premium-pack-error__text">
                <FormattedText value="hireCardPremiumPack-errorTextGeneric" />
            </div>
        );

        switch (immHireCardPremiumPack.get('hiringStatus')) {
            case KNOWN_ERROR_CODE:
                titleKey = 'hireCardPremiumPack-errorTitleGeneric';
                textElement = (
                    <div>
                        <div className="hire-card-premium-pack-error__text hire-card-premium-pack-error__text--margin-bottom">
                            <FormattedText
                                value={`hireCreditErrors-${immHireCardPremiumPack.get('errorMsg')}`}
                            />
                        </div>
                        <div className="hire-card-premium-pack-error__text">
                            <FormattedText
                                value="hireCardPremiumPack-errorTextCallUs2"
                            />
                        </div>
                        <div className="hire-card-premium-pack-error__phone">
                            <i className="hire-card-premium-pack-error__phone-icon icon icon-s-llamar" />
                            <FormattedText value="hireCardPremiumPack-phoneNumberClients" />
                        </div>
                    </div>
                );
                break;
            case REJECTED:
                titleKey = 'hireCardPremiumPack-errorTitleRejected';
                textElement = (
                    <div>
                        <div className="hire-card-premium-pack-error__text">
                            <FormattedText
                                value="hireCardPremiumPack-errorTextCallUs2"
                            />
                        </div>
                        <div className="hire-card-premium-pack-error__phone">
                            <i className="hire-card-premium-pack-error__phone-icon icon icon-s-llamar" />
                            <FormattedText value="hireCardPremiumPack-phoneNumberClients" />
                        </div>
                    </div>
                );
                break;
            case LOW_CREDIT_SCORE:
                titleKey = 'hireCardPremiumPack-errorTitleLowCreditScoreUpdated';
                const documentationLink = (
                    <a onClick={() => this.handleGoToDocumentation()} >
                        <FormattedText value="hireCardOpenCredit-documentation" />
                    </a>
                    );
                textElement = (
                    <div>
                        <div className="hire-card-via-t-error__text hire-card-via-t-error__text--margin-bottom">
                            <FormattedText
                                value={`hireCardPremiumPack-hireCardPremiumPack_lowCreditScoreMessage_updated_1`}
                            />
                            {documentationLink}
                            <FormattedText
                                value={`hireCardPremiumPack-hireCardPremiumPack_lowCreditScoreMessage_updated_2`}
                            />
                        </div>
                    </div>
                );
                break;
        }

        if (__CONTACT_CENTER__ && !hasAvailableAccounts) {
            titleKey = 'hireCardPremiumPack-errorTitleNotAvailableAccounts'
            textElement = (
                <div className="hire-card-premium-pack-error__text">
                    <FormattedText
                        value="hireCards-errorTextNotAvailableAccounts"
                    />
                </div>
            );
        }
        else if (maxAllowedNumberCards) {
            titleKey = 'hireCreditErrors-hireCreditErrors_maxAllowedCardsHiredTitle';
            textElement = formatText('hireCreditErrors-hireCreditErrors_maxAllowedCardsHired');
        }
        if(hireRestrictionFlag){
            titleKey = 'hireCard-errorRestrictionTitleAccount';
            textElement = <FormattedText value="hireCard-errorRestrictionSubtitleAccount" />
        }

        return {
            textElement,
            titleKey
        };
    }

    render() {
        const { hasAvailableAccounts, maxAllowedNumberCards, processDetail, hireRestrictionFlag } = this.props
        const { textElement, titleKey } = this.buildTexts();
        const goBackButton = hireRestrictionFlag ? {
            label: (
                <FormattedText
                    value="hireCard-errorRestrictionBackButtonText"
                />
            ),
            url: '/myprofile/global'
        }: hasAvailableAccounts && !maxAllowedNumberCards ?
        ({
            label: (
                <FormattedText
                    format="uppercase"
                    value="hireCardPremiumPack-errorBackButtonText"
                />
            ),
            url: '/myprofile/global'
        }) :
        ({
            label: (
                <FormattedText
                    format="uppercase"
                    value="hireCards-backButtonLabel"
                />
            ),
            url: '/myprofile/cards'
        });
        const cancleButton ={
            label: (
                <FormattedText
                    value="hireCard-errorRestrictionCancleButtonText"
                />
            ),
            url: '/myprofile/cards'
            };
        return (
            <WizardError
                errorMessage={formatText(titleKey)}
                mainButton={goBackButton}
                processDetail={processDetail}
                cancleButton={cancleButton}
                tealium={catalogue[analyticsId.PREMIUM_PACK_CARD_WIZARD_ERROR]({
                    productName: processDetail,
                    errorMessage: formatText(titleKey),
                })}
                isSecondVersion
            >
                <article className="hire-card-premium-pack-error">
                    {textElement}
                </article>
            </WizardError>
        );
    }
}

HireCardPremiumPackError.propTypes = {
    history: PropTypes.object.isRequired,
    immHireCardPremiumPack: PropTypes.object.isRequired,
    hasAvailableAccounts: PropTypes.bool,
    maxAllowedNumberCards: PropTypes.bool,
    processDetail: PropTypes.string,
    hireRestrictionFlag: PropTypes.bool
};

HireCardPremiumPackError.defaultProps =
{
    hireRestrictionFlag : false
}

module.exports = withRouter(HireCardPremiumPackError);
